/**
 * Enum that defines all SQL operators used in constructing a valid SQL query.
 */
export enum SqlOperator {
  And = 'AND',
  Or = 'OR'
}
